// app/javascript/controllers/file_upload_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropzone", "fileInput", "preview", "filename", "submitButton"]
  static values = { type: String }

  connect() {
    this.dropzoneTarget.addEventListener('dragenter', this.preventDefault)
    this.dropzoneTarget.addEventListener('dragover', this.preventDefault)
    this.dropzoneTarget.addEventListener('drop', this.preventDefault)
  }

  preventDefault(event) {
    event.preventDefault()
    event.stopPropagation()
  }

  openFileDialog() {
    this.fileInputTarget.click()
  }

  handleDragOver(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add('border-emerald-500', 'bg-emerald-500/10')
  }

  handleDragLeave(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove('border-emerald-500', 'bg-emerald-500/10')
  }

  handleDrop(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove('border-emerald-500', 'bg-emerald-500/10')
    
    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.fileInputTarget.files = files
      this.showPreview(files[0])
    }
  }

  handleFileSelect(event) {
    const file = event.target.files[0]
    if (file) {
      this.showPreview(file)
    }
  }

  showPreview(file) {
    this.filenameTarget.textContent = file.name
    this.previewTarget.classList.remove('hidden')
    this.dropzoneTarget.classList.add('hidden')
  }

  disableSubmit() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.value = "Importing..."
    }
  }

  removeFile() {
    this.fileInputTarget.value = ''
    this.previewTarget.classList.add('hidden')
    this.dropzoneTarget.classList.remove('hidden')
  }
}
